(function ($) {
    $(document).ready(function () {
        const $tables = $(document).find('table.sortable');

        $tables.each(function() {
            new Tablesort(this);
        });
    });
})(jQuery);
